import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Sessions = () => {
    return (
        <React.Fragment>
            <SEO title="Sessions | ICSI 2024" />
            <Header />
            <Breadcrumb
                image="images/banner/banner.jpg"
                title="Sessions"
                content="The Conference"
                contentTwo="Sessions"
                linkage="/"
            />

            {/* <HomeAbout /> */}
            <EmptyTwo>
                <div className="entry-content2">
                    <h2>
                        The information is to be announced.
                    </h2>
                    <div className="space-50"></div>

                    <div className="notice"></div>

                    {/* begin here */}


                   











                    {/* end here */}
                </div>
            </EmptyTwo>
            {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    );
};

export default Sessions;
